module.exports = __webpack_public_path__ + "karadeniz inşaat 2.jpg?8ba048fe6195466947da39130cbaae76";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/karadeniz inşaat 2.jpg
// module id = 343
// module chunks = 0